import api from './index.js'

export default {

  // 解析結果を取得
  getUserAnalysis(date = null) {
    if(date == null) {date = dateToFormatString(new Date(), '%Y%-%M%-%D%')}
    return api.get(`user_analysis.json?date=${date}`)
  },

  // ユーザー利用数を取得
  getAccessCounts(from, to) {
    return api.get('access_counts.json', { from, to });
  },

  // デバイス毎のユーザー利用数を取得
  getDeviceAccessCounts(deviceId, from, to) {
    return api.get(`access_counts/${deviceId}.json?from=${from}&to=${to}`)
  },

  // デバイスに紐づくログを取得
  getDeviceLogs(date = null) {
    if(date == null) {date = dateToFormatString(new Date(), '%Y%-%M%-%D%')}
    return api.get(`device_logs.json?date=${date}`)
  },

  // イベントに紐づくログを取得
  getEventLogs(date = null) {
    if(date == null) {date = dateToFormatString(new Date(), '%Y%-%M%-%D%')}
    return api.get(`event_logs.json?date=${date}`)
  },

  getAccessCountsByGender(params) {
    return api.get('access_counts_by_gender.json', params);
  },

  getAccessCountsByAge(params) {
    return api.get('access_counts_by_age.json', params);
  },
}
